import request from '@/utils/request';

const baseURL = process.env.VUE_APP_SORTING;

/**
 * 新增设备
 * @param {Object} data - 设备信息
 * @param {string} data.machineName - 设备名称
 * @param {string} data.machineCode - 设备编码
 * @param {number} data.chuteCount - 格口数量
 * @returns {Promise}
 */
export function addMachine(data) {
  return request({
    baseURL: baseURL,
    url: '/machine/add',
    method: 'post',
    data
  });
}

/**
 * 修改设备
 * @param {Object} data - 设备信息
 * @param {number} data.id - 设备ID
 * @returns {Promise}
 */
export function updateMachine(data) {
  return request({
    baseURL: baseURL,
    url: '/machine/update',
    method: 'post',
    data
  });
}

/**
 * 启用/停用设备
 * @param {Object} data - 请求参数
 * @param {number} data.id - 设备ID
 * @param {number} data.status - 状态：0-停用，1-启用
 * @returns {Promise}
 */
export function updateMachineStatus(data) {
  return request({
    baseURL: baseURL,
    url: '/machine/updateStatus',
    method: 'post',
    params: data
  });
}

/**
 * 分页查询设备
 * @param {Object} data - 查询参数
 * @param {number} data.pageNumber - 页码
 * @param {number} data.pageSize - 每页条数
 * @returns {Promise}
 */
export function getMachineList(data) {
  return request({
    baseURL: baseURL,
    url: '/machine/page',
    method: 'post',
    data
  });
}

/**
 * 查询所有设备列表
 * @returns {Promise}
 */
export function getAllMachineList() {
  return request({
    baseURL: baseURL,
    url: '/machine/list',
    method: 'get'
  });
}

/**
 * 修改格口数
 * @param {Object} data - 请求参数
 * @param {number} data.machineId - 设备ID
 * @param {number} data.chuteCount - 新格口数量
 * @returns {Promise}
 */
export function updateChuteCount(data) {
  return request({
    baseURL: baseURL,
    url: '/machine/updateChuteCount',
    method: 'post',
    params: data
  });
}

/**
 * 获取格口视图数据
 * @param {Object} params - 查询参数
 * @param {number} params.machineId - 设备ID
 * @returns {Promise}
 */
export function getChuteView(params) {
  return request({
    baseURL: baseURL,
    url: '/machine/chuteView',
    method: 'get',
    params
  });
}

/**
 * 修改格口状态
 * @param {Object} params - 请求参数
 * @param {number} params.chuteId - 格口ID
 * @param {number} params.status - 状态：0-关闭，1-开启，2-满袋
 * @returns {Promise}
 */
export function updateChuteStatus(params) {
  return request({
    baseURL: baseURL,
    url: '/machine/updateChuteStatus',
    method: 'post',
    params
  });
}

/**
 * 清理格口数据
 * @param {Object} params - 请求参数
 * @param {number} params.chuteId - 格口ID
 * @returns {Promise}
 */
export function clearChuteData(params) {
  return request({
    baseURL: baseURL,
    url: `/machine/clearChuteData?chuteId=${params.chuteId}`,
    method: 'post',
    params
  });
}

/**
 * 获取机器关联用户列表
 * @param {Object} params - 查询参数
 * @param {number} params.siteId - 中转仓ID
 * @returns {Promise}
 */
export function getMachineUsers(params) {
  return request({
    baseURL: baseURL,
    url: '/machine/userList?siteId=' + params.siteId,
    method: 'GET'
  });
}

export function exportChuteView(machineId) {
  return request({
    baseURL: baseURL,
    url: `/machine/chuteView/export?machineId=${machineId}`,
    method: 'get'
  });
}
